import styled from "styled-components";
import { Link } from "react-router-dom";

export const Content = styled("div")`
  padding: 22px 20px;
`;

export const Title = styled("h1")`
  font-size: 16px;
  margin: 0px;
`;

export const Subtitle = styled("h3")`
  font-size: 14px;
  font-weight: normal;
  margin: 0px;
`;

export const Cert = styled("div")`
  border: 1px solid ${({ theme }) => theme.colors.Primary};
  padding: 15px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
`;

export const AdeccoTitle = styled("h3")`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.Primary};
  font-weight: 500;
  margin: 0;
`;
export const CourseName = styled("h4")`
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  margin: 0;
`;
export const UserName = styled("p")`
  font-size: 12px;
  line-height: 15px;
  font-weight: 500;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;
export const Date = styled("p")`
  font-size: 12px;
  line-height: 15px;
  font-weight: 500;
  margin: 0;
`;
export const Actions = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: end;
`;

export const Module = styled("div")`
  display: flex;
  aling-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const NavUnits = styled(Link)`
  background-color: white;
  padding: 10px;
  display: block;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: inherit;
`;